import { useAppStore } from '@/stores/appStore';
import { DataDrawer } from './DataDrawer';

export function DataDrawerWrapper() {
  const {
    drawerOpen,
    drawerCompanyId,
    drawerCompanyName,
    drawerSource,
    recruiterIntelData,
    closeDrawer,
  } = useAppStore();

  const intel = recruiterIntelData[drawerCompanyId];
  const sourceData = intel?.[drawerSource as keyof typeof intel] as { data?: any; scrapedAt?: string } | undefined;

  return (
    <DataDrawer
      isOpen={drawerOpen}
      onClose={closeDrawer}
      companyName={drawerCompanyName}
      source={drawerSource as any}
      data={sourceData?.data}
      scrapedAt={sourceData?.scrapedAt}
    />
  );
}
